fx.ns("shared.popups", class  WarningOpenLocal   extends fx.components.Popup{
    
    constructor(photo)
    {
        super(photo);
        this.contentWidth = 550;
        this.contentHeight = 220;
    }

    get photo()
    {
        return this.data;
    }


    onReady()
    {
        super.onReady();

        this.on("click", this.close, this.okButton);

    }

    create()
    {
        super.create();
 
        this.addChild(new fx.components.Text({text:fx.text("Ouverture impossible"), className:"title center"}), {height:30, left:0, top:20, width:"100%"});
        this.addChild(new fx.components.Text({text:fx.text("L'application d'édition ne peut être ouverte que depuis notre site"), className:"text center"}), {height:80, left:0, top:80, width:"100%"});

        let hcontainer = new fx.components.HBox("buttons");

        this.okButton = new fx.components.Button({label : fx.text("Retourner sur Flexilivre.com"), type : "filled"});
        
        hcontainer.addChild(this.okButton, {width :300});

        this.addChild(hcontainer, {bottom:30, height:60, left:"center"});
    }


    close()
    {
        window.location = "https://www.flexilivre.com";
    }

});